import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from '../../../resources/img/smilewebsmall.png';

function Aside(props) {

    const [menustyle, setMenustyle] = useState('');
    const [activelink, setActivelink] = useState('');

    // Estados para submenús
    const [showSubmenuPacientes, setShowSubmenuPacientes] = useState(props.atencionPaciente || false);

    // Sub-submenús para Atención al Paciente
    const [showSubmenuHistoria, setShowSubmenuHistoria] = useState(false);
    const [showSubmenuRips, setShowSubmenuRips] = useState(false);
    const [showSubmenuDocumentos, setShowSubmenuDocumentos] = useState(false);
    const [showSubmenuGraficos, setShowSubmenuGraficos] = useState(false);

    // Submenú para Facturación
    const [showSubmenuFacturacion, setShowSubmenuFacturacion] = useState(false);
    
    // Submenú para Reportes
    const [showSubmenuReportes, setShowSubmenuReportes] = useState(false);

    useEffect(() => {
        setActivelink(props.activelink);
        if (!localStorage.getItem('userdata')) {
            setMenustyle('menu-collapsed');
        }
    }, [props.activelink]);

    // Actualizar estados cuando entra a modo atención
    useEffect(() => {
        if (props.atencionPaciente) {
            setShowSubmenuPacientes(true);
            // No abrimos los submenús por defecto
        }
    }, [props.atencionPaciente]);

    let permisos = [];
    if (localStorage.getItem('userdata')) {
        permisos = JSON.parse(localStorage.getItem('userdata')).up;
    }

    if (!localStorage.getItem('userdata')) {
        return null;
    }

    return (
        <>
            <aside className={'main-sidebar sidebar-dark-primary elevation-4 ' + menustyle + ' ' + props.sidebarCollapsed}>
                <Link to="/home" className="brand-link" style={{ display: 'inline-block', width: '100%', textAlign: 'center', borderBottom: 'none', backgroundColor: 'rgba(0,0,0,0.18)', padding: '0.5rem' }}>
                    <img 
                        src={logo} 
                        alt="SmileWEB Logo" 
                        className="brand-image logo-animated" 
                        style={{ float: 'initial', maxHeight: '50px', width: 'auto', transition: 'transform 0.3s ease' }} 
                    />
                </Link>

                <div className="sidebar" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 80px)' }}>
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                            <li className="nav-item" key="menu-item-1">
                                <Link to="/home" className={'nav-link ' + (activelink === 'home' ? "active" : "")}>
                                    <i className="nav-icon fas fa-home"></i>
                                    <p>Inicio</p>
                                </Link>
                            </li>

                            {permisos.includes('verAgenda') && (
                                <li className="nav-item" key="menu-item-3">
                                    <Link to="/agenda" className={'nav-link ' + (activelink === 'calendar' ? "active" : "")}>
                                        <i className="nav-icon far fa-calendar-alt"></i>
                                        <p>Agenda</p>
                                    </Link>
                                </li>
                            )}

                            {permisos.includes('verInfoPacientes') && (
                                <>
                                    {props.atencionPaciente ? (
                                        <li className={`nav-item has-treeview ${showSubmenuPacientes ? 'menu-open' : ''}`} key="menu-item-4">
                                            <a href="#" className={'nav-link ' + (activelink === 'patients' ? "active" : "")} onClick={(e) => { e.preventDefault(); setShowSubmenuPacientes(!showSubmenuPacientes); }}>
                                                <i className="nav-icon far fa-user"></i>
                                                <p>
                                                    Clientes
                                                    <i className="right fas fa-angle-right"></i>
                                                </p>
                                            </a>
                                            <ul className="nav nav-treeview" style={{ display: showSubmenuPacientes ? 'block' : 'none' }}>

                                                {/* GRUPO 1: Historia Clínica */}
                                                <li className={`nav-item has-treeview ${showSubmenuHistoria ? 'menu-open' : ''}`}>
                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); setShowSubmenuHistoria(!showSubmenuHistoria); }} style={{ paddingLeft: '20px' }}>
                                                        <i className="fas fa-notes-medical nav-icon" style={{ fontSize: '13px' }}></i>
                                                        <p style={{ fontSize: '13px' }}>
                                                            Historia Clínica
                                                            <i className="right fas fa-angle-right"></i>
                                                        </p>
                                                    </a>
                                                    <ul className="nav nav-treeview" style={{ display: showSubmenuHistoria ? 'block' : 'none' }}>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirEvolucion) props.abrirEvolucion(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-edit nav-icon text-primary" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Evolución</p>
                                                            </a>
                                                        </li>
                                                        {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
                                                        {/* <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirHistoriaClinica) props.abrirHistoriaClinica(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-file-medical-alt nav-icon text-primary" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Historia Clínica (Antigua)</p>
                                                            </a>
                                                        </li> */}
                                                        {props.abrirHistoriaClinicaJson && (
                                                            <li className="nav-item">
                                                                <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); props.abrirHistoriaClinicaJson(); }} style={{ paddingLeft: '35px' }}>
                                                                    <i className="fas fa-file-medical-alt nav-icon text-primary" style={{ fontSize: '12px' }}></i>
                                                                    <p style={{ fontSize: '12px' }}>Historia Clínica</p>
                                                                </a>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </li>

                                                {/* GRUPO 2: RIPS */}
                                                <li className={`nav-item has-treeview ${showSubmenuRips ? 'menu-open' : ''}`}>
                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); setShowSubmenuRips(!showSubmenuRips); }} style={{ paddingLeft: '20px' }}>
                                                        <i className="fas fa-file-invoice-dollar nav-icon" style={{ fontSize: '13px' }}></i>
                                                        <p style={{ fontSize: '13px' }}>
                                                            RIPS
                                                            <i className="right fas fa-angle-right"></i>
                                                        </p>
                                                    </a>
                                                    <ul className="nav nav-treeview" style={{ display: showSubmenuRips ? 'block' : 'none' }}>
                                                        {/* Si es facturador (facturador === 0): mostrar RIPS FEV y Convenio */}
                                                        {props.esFacturador && (
                                                            <>
                                                                <li className="nav-item">
                                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirRipsFev) props.abrirRipsFev(); }} style={{ paddingLeft: '35px' }}>
                                                                        <i className="fas fa-file-invoice nav-icon text-info" style={{ fontSize: '12px' }}></i>
                                                                        <p style={{ fontSize: '12px' }}>RIPS con FEV</p>
                                                                    </a>
                                                                </li>
                                                                <li className="nav-item">
                                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirRipsConvenio) props.abrirRipsConvenio(); }} style={{ paddingLeft: '35px' }}>
                                                                        <i className="fas fa-handshake nav-icon text-info" style={{ fontSize: '12px' }}></i>
                                                                        <p style={{ fontSize: '12px' }}>RIPS Convenio</p>
                                                                    </a>
                                                                </li>
                                                            </>
                                                        )}
                                                        {/* Si NO es facturador (facturador === 1): mostrar RIPS Sin FEV */}
                                                        {!props.esFacturador && (
                                                            <li className="nav-item">
                                                                <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirRipsSinFev) props.abrirRipsSinFev(); }} style={{ paddingLeft: '35px' }}>
                                                                    <i className="fas fa-file-medical nav-icon text-info" style={{ fontSize: '12px' }}></i>
                                                                    <p style={{ fontSize: '12px' }}>RIPS sin FEV</p>
                                                                </a>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </li>

                                                {/* GRUPO 3: Documentos */}
                                                <li className={`nav-item has-treeview ${showSubmenuDocumentos ? 'menu-open' : ''}`}>
                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); setShowSubmenuDocumentos(!showSubmenuDocumentos); }} style={{ paddingLeft: '20px' }}>
                                                        <i className="fas fa-folder-open nav-icon" style={{ fontSize: '13px' }}></i>
                                                        <p style={{ fontSize: '13px' }}>
                                                            Documentos
                                                            <i className="right fas fa-angle-right"></i>
                                                        </p>
                                                    </a>
                                                    <ul className="nav nav-treeview" style={{ display: showSubmenuDocumentos ? 'block' : 'none' }}>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirExamenes) props.abrirExamenes(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-vial nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Exámenes</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirFormulas) props.abrirFormulas(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-prescription nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Fórmulas</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirIncapacidades) props.abrirIncapacidades(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-user-injured nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Incapacidades</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirRecomendaciones) props.abrirRecomendaciones(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-clipboard-list nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Recomendaciones</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirRemisiones) props.abrirRemisiones(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-paper-plane nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Remisiones</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirContraremisiones) props.abrirContraremisiones(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-reply nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Contraremisiones</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirConsentimientos) props.abrirConsentimientos(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-file-signature nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Consentimientos</p>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>

                                                {/* GRUPO 4: Gráficos */}
                                                <li className={`nav-item has-treeview ${showSubmenuGraficos ? 'menu-open' : ''}`}>
                                                    <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); setShowSubmenuGraficos(!showSubmenuGraficos); }} style={{ paddingLeft: '20px' }}>
                                                        <i className="fas fa-chart-line nav-icon" style={{ fontSize: '13px' }}></i>
                                                        <p style={{ fontSize: '13px' }}>
                                                            Gráficos
                                                            <i className="right fas fa-angle-right"></i>
                                                        </p>
                                                    </a>
                                                    <ul className="nav nav-treeview" style={{ display: showSubmenuGraficos ? 'block' : 'none' }}>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirOdontograma) props.abrirOdontograma(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-tooth nav-icon text-warning" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Odontograma</p>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a href="#" className="nav-link" onClick={(e) => { e.preventDefault(); if (props.abrirToxina) props.abrirToxina(); }} style={{ paddingLeft: '35px' }}>
                                                                <i className="fas fa-syringe nav-icon text-danger" style={{ fontSize: '12px' }}></i>
                                                                <p style={{ fontSize: '12px' }}>Toxina Botulínica</p>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>

                                            </ul>
                                        </li>
                                    ) : (
                                        <li className="nav-item" key="menu-item-4-normal">
                                            <Link to="/menu-pacientes" className={'nav-link ' + (activelink === 'patients' ? "active" : "")}>
                                                <i className="nav-icon far fa-user"></i>
                                                <p>Clientes</p>
                                            </Link>
                                        </li>
                                    )}
                                </>
                            )}

                            {permisos.includes('facturacion') && (
                                <li className={`nav-item has-treeview ${showSubmenuFacturacion ? 'menu-open' : ''}`} key="menu-item-7">
                                    <Link to="/menu-facturacion" className={'nav-link ' + (activelink === 'billing' ? "active" : "")} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                            <i className="nav-icon fas fa-wallet"></i>
                                            <p style={{ margin: 0 }}>Contabilidad</p>
                                        </span>
                                        <i 
                                            className="right fas fa-angle-right" 
                                            onClick={(e) => { 
                                                e.preventDefault(); 
                                                e.stopPropagation(); 
                                                setShowSubmenuFacturacion(!showSubmenuFacturacion); 
                                            }}
                                            style={{ cursor: 'pointer', padding: '5px' }}
                                        ></i>
                                    </Link>
                                    <ul className="nav nav-treeview" style={{ display: showSubmenuFacturacion ? 'block' : 'none' }}>
                                        {/* Presupuesto */}
                                        {permisos.includes('ver_listado_presupuestos') && (
                                            <li className="nav-item">
                                                <Link to="/listado-presupuestos" className="nav-link" style={{ paddingLeft: '20px' }}>
                                                    <i className="fas fa-calculator nav-icon text-warning" style={{ fontSize: '12px' }}></i>
                                                    <p style={{ fontSize: '12px' }}>Presupuestos</p>
                                                </Link>
                                            </li>
                                        )}
                                        {/* Facturación */}
                                        {permisos.includes('ver_listado_facturas') && (
                                            <li className="nav-item">
                                                <Link to="/listado-facturas" className="nav-link" style={{ paddingLeft: '20px' }}>
                                                    <i className="fas fa-file-invoice nav-icon text-success" style={{ fontSize: '12px' }}></i>
                                                    <p style={{ fontSize: '12px' }}>Facturación</p>
                                                </Link>
                                            </li>
                                        )}
                                        {/* Documento Soporte */}
                                        {permisos.includes('ver_listado_documentos_soporte') && (
                                            <li className="nav-item">
                                                <Link to="/listado-documentos-soporte" className="nav-link" style={{ paddingLeft: '20px' }}>
                                                    <i className="fas fa-file-alt nav-icon text-info" style={{ fontSize: '12px' }}></i>
                                                    <p style={{ fontSize: '12px' }}>Documento Soporte</p>
                                                </Link>
                                            </li>
                                        )}
                                        {/* Egresos */}
                                        {permisos.includes('ver_listado_documentos_soporte') && (
                                            <li className="nav-item">
                                                <Link to="/listado-egresos" className="nav-link" style={{ paddingLeft: '20px' }}>
                                                    <i className="fas fa-money-bill-wave nav-icon text-danger" style={{ fontSize: '12px' }}></i>
                                                    <p style={{ fontSize: '12px' }}>Egresos</p>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}

                            {(permisos.includes('adminInventario') || permisos.includes('verIndicadores')) && (
                                <li className="nav-item" key="menu-item-8">
                                    <Link to="/indicadores" className={'nav-link ' + (activelink === 'indicators' ? "active" : "")}>
                                        <i className="nav-icon fas fa-chart-line"></i>
                                        <p>Indicadores</p>
                                    </Link>
                                </li>
                            )}

                            {permisos.includes('verEstadisticas') && (
                                <li className={`nav-item has-treeview ${showSubmenuReportes ? 'menu-open' : ''}`} key="menu-item-6">
                                    <Link to="/estadisticas" className={'nav-link ' + (activelink === 'reports' ? "active" : "")} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                            <i className="nav-icon fas fa-file-alt"></i>
                                            <p style={{ margin: 0 }}>Reportes</p>
                                        </span>
                                        <i 
                                            className="right fas fa-angle-right" 
                                            onClick={(e) => { 
                                                e.preventDefault(); 
                                                e.stopPropagation(); 
                                                setShowSubmenuReportes(!showSubmenuReportes); 
                                            }}
                                            style={{ cursor: 'pointer', padding: '5px' }}
                                        ></i>
                                    </Link>
                                    <ul className="nav nav-treeview" style={{ display: showSubmenuReportes ? 'block' : 'none' }}>
                                        <li className="nav-item">
                                            <Link to="/estadisticas" className="nav-link" style={{ paddingLeft: '35px' }}>
                                                <i className="fas fa-chart-bar nav-icon" style={{ fontSize: '13px' }}></i>
                                                <p style={{ fontSize: '13px' }}>Estadísticas</p>
                                            </Link>
                                        </li>
                                        {permisos.includes('ver_reporte_libro_diario') && (
                                            <li className="nav-item">
                                                <Link to="/libro-diario" className="nav-link" style={{ paddingLeft: '35px' }}>
                                                    <i className="fas fa-book nav-icon" style={{ fontSize: '13px' }}></i>
                                                    <p style={{ fontSize: '13px' }}>Libro Diario</p>
                                                </Link>
                                            </li>
                                        )}
                                        {permisos.includes('ver_reporte_facturas_recibos') && (
                                            <li className="nav-item">
                                                <Link to="/facturas-recibos" className="nav-link" style={{ paddingLeft: '35px' }}>
                                                    <i className="fas fa-file-invoice-dollar nav-icon" style={{ fontSize: '13px' }}></i>
                                                    <p style={{ fontSize: '13px' }}>Facturas vs Recibos</p>
                                                </Link>
                                            </li>
                                        )}
                                        {permisos.includes('ver_reporte_documentos_egresos') && (
                                            <li className="nav-item">
                                                <Link to="/documentos-egresos" className="nav-link" style={{ paddingLeft: '35px' }}>
                                                    <i className="fas fa-file-alt nav-icon" style={{ fontSize: '13px' }}></i>
                                                    <p style={{ fontSize: '13px' }}>Documentos vs Egresos</p>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            )}

                            {permisos.includes('verLaboratorio') && (
                                <li className="nav-item" key="menu-item-5">
                                    <Link to="/menu-laboratorio" className={'nav-link ' + (activelink === 'laboratory' ? "active" : "")}>
                                        <i className="nav-icon fas fa-flask"></i>
                                        <p>Laboratorio</p>
                                    </Link>
                                </li>
                            )}

                            {permisos.includes('configuracion') && (
                                <li className="nav-item" key="menu-item-9">
                                    <Link to="/settings" className={'nav-link ' + (activelink === 'settings' ? "active" : "")}>
                                        <i className="nav-icon fas fa-cogs"></i>
                                        <p>Configuración</p>
                                    </Link>
                                </li>
                            )}

                        </ul>
                    </nav>
                </div>
            </aside>
            <div id="sidebar-overlay" onClick={() => { document.body.classList.remove('sidebar-open'); document.body.classList.add('sidebar-closed'); document.body.classList.add('sidebar-collapse'); }}></div>
        </>
    );
}

export default Aside;